import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GetBrText } from '../utilities';

// URL�p�����[�^�̍폜
const urldel = () => {
    var url = location.href ;
    var new_url = url.replace(/\?.*$/,"");
    window.location.href = new_url;
    window.location.replace() 
};

const mapStateToProps = state => ({
  resultDisplay: state.result_page,
  form_settings: state.form_settings
});

const ResultPage = ({ resultDisplay, form_settings }) => {
  if (!resultDisplay) {
    return null;
  }
  return (
    <div className="form-complete">
      <p className="complete-message">{GetBrText(form_settings.form_text.finish_inquiry)}</p>
      <div className="button-forms">
        <input type="button" value={form_settings.form_text.back_contact}
          className="btn-fanuc btn-fanuc--yellow" onClick={() => {
//            window.location.reload()
            urldel()
          }} />
      </div>

    </div>
  );
};

ResultPage.propTypes = {
  resultDisplay: PropTypes.bool.isRequired,
  form_settings: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(ResultPage);
